import { useMemo } from 'react'
import { useLoadData } from '@/v2/containers/calendar/PeriodOfTime/hooks/useLoadData'
import {
  roundStartHour,
  roundEndHour,
  DEFAULT_START,
  DEFAULT_END,
} from '@/v2/containers/calendar/PeriodOfTime/hooks/usePeriodOfTime'

export const useAvailableTimeSlots = date => {
  const { loading, error, startHour, endHour } = useLoadData(date)

  const defaultStartHour =
    startHour != null
      ? roundStartHour(Math.min(startHour, DEFAULT_START))
      : DEFAULT_START
  const defaultEndHour =
    endHour != null ? roundEndHour(Math.max(endHour, DEFAULT_END)) : DEFAULT_END

  const appointmentDuration = 15

  return useMemo(() => {
    const arrayRange = Array.from(
      {
        length: Math.ceil(
          (defaultEndHour - defaultStartHour) / appointmentDuration
        ),
      },
      (x, i) => i * appointmentDuration + defaultStartHour
    )
    return { loading, error, timeSlots: arrayRange }
  }, [loading, error, defaultStartHour, defaultEndHour])
}
